import { Row, Col, Skeleton, Tooltip, message } from "antd";
import { RiUserSearchFill } from "react-icons/ri";
import axios from "axios";
import classes from "../Pages.module.css";
import { useState, useEffect, useContext } from "react";
import DataContext from "../../../Context/dataContext";
import EmployeeTable from "../EmployeeTable/EmployeeTable";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import {  getFormPermissions } from '../../../utils/checkDayPermission';

const ItemDetails = (props) => {
  const employeeData = useContext(DataContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState(null);
  // const [drows, setDRows] = useState(null);

  // Get permission flags for the current form including day-based checks
  const { canAdd, canModify, canDelete, canQuery, messages } = getFormPermissions("Item Master", employeeData);
console.log("canAdd", canAdd);
console.log("canModify", canModify);
console.log("canDelete", canDelete);
console.log("canQuery", canQuery);
console.log("messages", messages);


  useEffect(() => {
    // setDRows(null);
    setRows(null);
    setColumns([]);

    axios
      .get(employeeData.URL + "/api/v1/items", {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response, "6999999999999999999999999999999999999999999999999999999999999999999999999");
        setColumns((columns) => {
          let newCols = response.data.data.items.fields.map((col) => {
            return {
              name: col.name,
              title: col.name.split("_").join(" ").toLowerCase(),
            };
          });

          return [
            { name: "D", title: "D" },
            { name: "V", title: "V" },
            { name: "SNO", title: "SNo" },
            ...newCols,
          ];
        });

        setRows((rows) => {
          return response.data.data.items.rows.map((row, index) => ({
            D: canDelete ? (
              <Tooltip placement="bottom" title="Delete" color="red">
                <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                  <AiFillDelete
                    onClick={(event) => {
                      // Double-check permission before executing delete
                      if (canDelete) {
                        deleteHandler(
                          event,
                          index,
                          response.data.data.items.rows,
                          row["item_code"]
                        );
                      }
                    }}
                    style={{
                      color: "red",
                      fontWeight: "bolder",
                      fontSize: "0.8rem",
                    }}
                  />
                </Link>
              </Tooltip>
            ) : (
              <Tooltip 
                placement="bottom" 
                title={messages.delete}
                color="red"
              >
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <AiFillDelete
                    style={{
                      color: "red",
                      fontWeight: "bolder",
                      fontSize: "0.8rem",
                    }}
                  />
                </span>
              </Tooltip>
            ),
            V: canModify ? (
              <Tooltip placement="bottom" title="View" color="#1777C4">
                <Link
                  to={
                    "/sales/itemMaster/item-details-view/" + row["item_code"]
                  }
                  style={{ color: "#1777C4", fontWeight: "bolder" }}
                >
                  <RiUserSearchFill
                    style={{
                      color: "#1777C4",
                      fontWeight: "bolder",
                      fontSize: "0.9rem",
                    }}
                  />
                </Link>
              </Tooltip>
            ) : (
              <Tooltip 
                placement="bottom" 
                title={messages.query}
                color="#1777C4"
              >
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <RiUserSearchFill
                    style={{
                      color: "#1777C4",
                      fontWeight: "bolder",
                      fontSize: "0.9rem",
                    }}
                  />
                </span>
              </Tooltip>
            ),
            SNO: index + 1,
            ...row,
          }));
        });
      })
      .catch((error) => {
        message.error("Failed to fetch items. Please try again.");
      });
  }, [employeeData, canDelete, canQuery]);

  const deleteHandler = (event, index, newrows, code) => {
    if (!canDelete) {
      message.warning(messages.delete || "You don't have permission to delete items.");
      return;
    }

    setRows(null);

    axios
      .delete(employeeData.URL + "/api/v1/items/" + code.toString(), {
        withCredentials: true,
      })
      .then((response) => {
        const { message: backendMessage, isUsed } = response.data;

        if (response.data.status === "success") {
          message.success(backendMessage);
        } else {
          message.warning(backendMessage);
        }

        let rowvals = newrows;
        if (!isUsed) {
          rowvals = newrows.filter((row) => row["item_code"] !== code);
        }

        setRows((rows) => {
          return rowvals.map((row, idx) => ({
            D: canDelete ? (
              <Tooltip placement="bottom" title="Delete" color="red">
                <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                  <AiFillDelete
                    onClick={(event) => {
                      // Double-check permission before executing delete
                      if (canDelete) {
                        deleteHandler(event, idx, rowvals, row["item_code"]);
                      }
                    }}
                    style={{
                      color: "red",
                      fontWeight: "bolder",
                      fontSize: "0.8rem",
                    }}
                  />
                </Link>
              </Tooltip>
            ) : (
              <Tooltip 
                placement="bottom" 
                title={messages.delete}
                color="red"
              >
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <AiFillDelete
                    style={{
                      color: "red",
                      fontWeight: "bolder",
                      fontSize: "0.8rem",
                    }}
                  />
                </span>
              </Tooltip>
            ),
            V: canModify ? (
              <Tooltip placement="bottom" title="View" color="#1777C4">
                <Link
                  to={
                    "/sales/itemMaster/item-details-view/" + row["item_code"]
                  }
                  style={{ color: "#1777C4", fontWeight: "bolder" }}
                >
                  <RiUserSearchFill
                    style={{
                      color: "#1777C4",
                      fontWeight: "bolder",
                      fontSize: "0.9rem",
                    }}
                  />
                </Link>
              </Tooltip>
            ) : (
              <Tooltip 
                placement="bottom" 
                title="You don't have permission to view items" 
                color="#1777C4"
              >
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <RiUserSearchFill
                    style={{
                      color: "#1777C4",
                      fontWeight: "bolder",
                      fontSize: "0.9rem",
                    }}
                  />
                </span>
              </Tooltip>
            ),
            SNO: idx + 1,
            ...row,
          }));
          
        });
      })
      .catch((error) => {
        message.error("Failed to delete item. Please try again.");
        setRows((rows) => {
          return newrows.map((row, idx) => ({
            D: canDelete ? (
              <Tooltip placement="bottom" title="Delete" color="red">
                <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                  <AiFillDelete
                    onClick={(event) => {
                      // Double-check permission before executing delete
                      if (canDelete) {
                        deleteHandler(event, idx, newrows, row["item_code"]);
                      }
                    }}
                    style={{
                      color: "red",
                      fontWeight: "bolder",
                      fontSize: "0.8rem",
                    }}
                  />
                </Link>
              </Tooltip>
            ) : (
              <Tooltip 
                placement="bottom" 
                title={messages.delete}
                color="red"
              >
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <AiFillDelete
                    style={{
                      color: "red",
                      fontWeight: "bolder",
                      fontSize: "0.8rem",
                    }}
                  />
                </span>
              </Tooltip>
            ),
            V:  canModify ?(
              <Tooltip placement="bottom" title="View" color="#1777C4">
                <Link
                  to={
                    "/sales/itemMaster/item-details-view/" + row["item_code"]
                  }
                  style={{ color: "#1777C4", fontWeight: "bolder" }}
                >
                  <RiUserSearchFill
                    style={{
                      color: "#1777C4",
                      fontWeight: "bolder",
                      fontSize: "0.9rem",
                    }}
                  />
                </Link>
              </Tooltip>
            ) : (
              <Tooltip 
                placement="bottom" 
                title="You don't have permission to view items" 
                color="#1777C4"
              >
                <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                  <RiUserSearchFill
                    style={{
                      color: "#1777C4",
                      fontWeight: "bolder",
                      fontSize: "0.9rem",
                    }}
                  />
                </span>
              </Tooltip>
            ),
            SNO: idx + 1,
            ...row,
          }));
        });
      });
  };

  return (
    <>
      <Row className={classes["Row"]}>
        <Col md={14}>
          <p className={classes["Title"]}>Item Details</p>
        </Col>
        <Col className={classes["Col"]} md={10}></Col>
      </Row>
      <p></p>
      <Row className={classes["Row"]}>
        <Col lg={19} md={17}></Col>
        <Col className={classes["Col"]} lg={5} md={7}>
          <Tooltip 
            placement="bottom" 
            title={!canAdd ? messages.add : ""}
          >
            <span>
              <Link 
                to={canAdd ? "/sales/itemMaster/item-create" : "#"}
                onClick={(e) => !canAdd && e.preventDefault()}
              >
                <button 
                  className={classes["ProfileButton"]} 
                  disabled={!canAdd}
                  style={{
                    opacity: canAdd ? 1 : 0.5,
                    cursor: canAdd ? 'pointer' : 'not-allowed'
                  }}
                >
                  Add an Item
                </button>
              </Link>
            </span>
          </Tooltip>
        </Col>
      </Row>
      <p></p>
      {rows && columns.length > 0 ? (
        <>
          <EmployeeTable data={rows} columns={columns} val={true} />
        </>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default ItemDetails;
